import {
  sendPostRequest, sendPutRequest, sendDeleteRequest, sendGetRequest
} from "@/helper/requests";
import surveys from "@/urls/roles/admin";

const state = {

}

const getters = {
}

const mutations = {
}

const actions = {
  loadFieldList: ({commit}, {url, finalizer, catcher}) => {
    /**
     * Загружает список всех полей формы
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} params - Параметры запроса
     * @param {string} url - URL для запроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    if (!url)
      url = surveys.ADMIN.FIELDS.LIST()
    sendGetRequest(
      url,
      (data) => finalizer(data, url),
      catcher
    )
  },
  loadFieldDetail: ({commit, getters}, {id, finalizer, catcher}) => {
    /**
     * Загружает детальную информацию о конкретном поле
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Function} getters - Геттеры Vuex
     * @param {number} id - Идентификатор поля
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    sendGetRequest(
      surveys.ADMIN.FIELDS.DETAIL(id),
      finalizer,
      catcher
    )
  },
  createField: ({dispatch, commit}, {data, finalizer, catcher}) => {
    /**
     * Создает новое поле формы
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} data - Данные для создания поля
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    sendPostRequest(
      surveys.ADMIN.FIELDS.SAVE(),
      data,
      finalizer,
      catcher
    )
  },
  updateField: ({dispatch, commit}, {data, finalizer, catcher}) => {
    /**
     * Обновляет существующее поле формы
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} data - Обновленные данные поля
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    sendPutRequest(
      surveys.ADMIN.FIELDS.EDIT(data.id),
      data,
      finalizer,
      catcher
    )
  },
  deleteField: ({dispatch, commit}, {data, finalizer, catcher}) => {
    /**
     * Удаляет поле формы
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} data - Данные для удаления поля
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    sendDeleteRequest(
      surveys.ADMIN.FIELDS.DELETE(data.id),
      finalizer,
      catcher
    )
  },
}


export default {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
}
